import React, { Component } from 'react';
import { Form, Modal, Select, InputNumber, message } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import './index.less';

const { Option } = Select;
const api = services.api;
/**
 * 商品资料预览商品
 */
class Maxsalenum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            inputVisible: props.rows.saleNumStatus == '1' ? true : false,
        };
        console.log('props是什么东西？',this.props)
    }

    showModal = () => {
        console.log(this.props.rows);
        this.setState({
            visible: true,
            inputVisible: this.props.rows.saleNumStatus == '1' ? true : false,
        });
        this.props.form.setFields({
            saleNumStatus: {
                value: this.props.rows.saleNumStatus,
            },
            maxSaleNum: {
                value: this.props.rows.maxSaleNum,
            },
        });
    };

    handleOk = (e) => {
        console.log(this.props.entity);
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let value;
                if (this.state.inputVisible) {
                    value = {
                        max_sale_num: values.maxSaleNum,
                        sale_num_status: values.saleNumStatus,
                    };
                } else {
                    value = {
                        sale_num_status: values.saleNumStatus,
                    };
                }

                api.put(value, { apiPath: `/products/${this.props.rows.id}` })
                    .then(() => {
                        message.success('修改成功');
                    })
                    .catch(errorHandle);
                this.setState({
                    visible: false,
                });
                let params = {
                    type: 'FK_POINTS'
                }
                // 列表数据刷新
                this.props.entity.search({
                    ...params,
                    ...this.props.entity.filters,
                });
            } else {
                message.error('请填写完整表单再提交');
            }
        });
    };

    handleCancel = (e) => {
        this.props.form.resetFields();
        this.setState({
            visible: false,
        });
    };

    handleSelectChange = (value) => {
        if (value == '1') {
            this.setState(
                {
                    inputVisible: true,
                },
                () => {
                    // this.props.form.setFields({
                    //     max_sale_num: {
                    //         value: 10,
                    //     },
                    // });
                }
            );
        } else {
            this.setState({
                inputVisible: false,
            });
        }
    };

    render() {
        const { visible, inputVisible } = this.state;
        return (
            <div>
                <a target="_blank" onClick={this.showModal}>
                    限购设置
                </a>
                <Modal visible={visible} onOk={this.handleOk} onCancel={this.handleCancel}>
                    <Form layout="vertical">
                        <Form.Item label="是否限制购买量">
                            {this.props.form.getFieldDecorator('saleNumStatus', {
                                rules: [{ required: true, message: '请选择是否限制购买量' }],
                            })(
                                <Select
                                    placeholder="请选择是否限制购买量"
                                    onChange={this.handleSelectChange}
                                >
                                    <Option value="1">是</Option>
                                    <Option value="0">否</Option>
                                </Select>
                            )}
                        </Form.Item>
                        {inputVisible && (
                            <>
                                <Form.Item label="用户最多可兑换量">
                                    {this.props.form.getFieldDecorator('maxSaleNum', {
                                        rules: [{ required: true, message: '用户最多可兑换量' }],
                                    })(<InputNumber />)}
                                </Form.Item>
                            </>
                        )}
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(Maxsalenum);
